import { render, staticRenderFns } from "./BookingPage.vue?vue&type=template&id=7654d00c&scoped=true&"
import script from "./BookingPage.vue?vue&type=script&lang=js&"
export * from "./BookingPage.vue?vue&type=script&lang=js&"
import style0 from "./BookingPage.vue?vue&type=style&index=0&id=7654d00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7654d00c",
  null
  
)

export default component.exports